// Rider: what this person does when they are the passenger. Credit and spend, the
// rides themselves, and the support notes — which live here rather than on Account
// because in practice every note on this page is about a ride that went wrong.
//
// Money and the ride list are the long ones, so they take the left column; notes sit
// level with the top of the money, which is what a support agent reads while on the
// call.
//
// Reviews sits here with no aggregate above it, unlike the Driver tab: what a driver or a
// co-rider says about a rider is `was_positive_exp`, a boolean, so there is nothing to
// average and no rider score to head the section with. Inventing one would be a new
// metric rather than a read.
import React from 'react';
import { TabGrid } from './parts';

import RiderCashFlowCard from '../../components/widgets/Users/RiderCashFlowCard';
import UserNotesCard from '../../components/widgets/Users/UserNotesCard';
import RideHistoryCard from '../../components/widgets/Users/RideHistoryCard';
import UserReviewsCard from '../../components/widgets/Users/UserReviewsCard';

const RiderTab = ({ user }) => (
  <TabGrid
    left={
      <>
        <RiderCashFlowCard user={user} />
        <RideHistoryCard user={user} />
      </>
    }
    right={
      <>
        <UserReviewsCard user={user} direction="rider" />
        <UserNotesCard user={user} />
      </>
    }
  />
);

export default RiderTab;
